export default __webpack_public_path__ + "static/media/2735.25448228.svg";